var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('listHeader'),_c('router-view',{style:(_vm.contentHeight)}),_c('router-link',{attrs:{"to":"/:id"}}),_c('listFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }